// Navbar.js
import React from 'react';

function Navbar({ language, setLanguage, content }) {
  const navStyle = {
    backgroundColor: '#164B72',
    color: 'white',
    padding: '15px 30px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'fixed', // Makes navbar stick to top
    top: 0,
    left: 0,
    width: '100%',
    zIndex: 1000, // Ensures navbar is above other content
    boxSizing: 'border-box' // Ensures padding doesn't add to width
  };

  const titleStyle = {
    fontFamily: 'Minolta',
    fontSize: '2em',
    margin: 0,
    lineHeight: '1.2'
  };

  const subTitleStyle = {
    fontFamily: 'Quicksand',
    margin: 0,
    fontSize: '1.26em',
    fontWeight: 'normal'
  };

  const navLinksStyle = {
    display: 'flex',
    alignItems: 'center'
  };

  const linkStyle = {
    fontFamily: 'Quicksand',
    color: 'white',
    textDecoration: 'none',
    margin: '0 15px',
    border: 'none', // No borders
    background: 'none',
    cursor: 'pointer',
    fontSize: '1em'
  };

  const langButtonStyle = {
    ...linkStyle,
    padding: '5px 8px',
    border: '1px solid white', // Slight border for language buttons for distinction
    borderRadius: '4px',
    marginLeft: '5px'
  };

  const activeLangButtonStyle = {
    ...langButtonStyle,
    backgroundColor: 'white',
    color: '#164B72'
  }

  return (
    <nav style={navStyle}>
      <div>
        <h1 style={titleStyle}>benjamin hicks</h1> {/* From user description, matches PDF source [1] */}
        <h2 style={subTitleStyle}>location sound production</h2> {/* From user description, matches PDF source [1] */}
      </div>
      <div style={navLinksStyle}>
        <a href="#home" style={linkStyle}>{content.navHome}</a>
        <a href="#about" style={linkStyle}>{content.navAbout}</a>
        <a href="#gear" style={linkStyle}>{content.navGear}</a>
        <a href="#work" style={linkStyle}>{content.navWork}</a>
        <a href="#contact" style={linkStyle}>{content.navContact}</a>
        <button
          style={language === 'en' ? activeLangButtonStyle : langButtonStyle}
          onClick={() => setLanguage('en')}
        >
          EN
        </button>
        <button
          style={language === 'pt' ? activeLangButtonStyle : langButtonStyle}
          onClick={() => setLanguage('pt')}
        >
          PT
        </button>
      </div>
    </nav>
  );
}

export default Navbar;